<template>
  <div>
    <div class="ft-container">
      <FeaturedPlaceholder v-if="!contents" />
      <div class="feature-corousel-container">
        <div class="slide-head-btns" v-if="contents">
          <div id="slide-feature-controls" class="slide-controls">
            <button type="button" class="btn-slide-controls prev">
              <img src="@/assets/icons/prev-arrow50.png" alt="previous arrow" />
            </button>
            <button type="button" class="btn-slide-controls next">
              <img src="@/assets/icons/next-arrow50.png" alt="next arrow" />
            </button>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="featured-carousel" :id="`featured-carousel`" v-if="showFeaturedCarousel">
          <div class="ft-card" v-for="(content, key) in contents" :key="key">
            <div
              class="ft-card-box"
              :style="{
                'height': `${cardHeight}px`
              }"
              @mouseenter="contentCursorHover"
              @mouseleave="contentCursorNotHover"
              @click="detailClick(content)"
            >
              <div
                class="ft-card-box-contain"
                :style="{
                    'background-image': `url(${ getPoster(content) })`
                  }"
              >
                <!-- <img :src="getPoster(content)" width="100%"> -->
              </div>
              <div class="ft-card-misc">
                <div class="ft-card-left">
                  <!-- Content Title -->
                  <h4 class="card-title">{{content.title}}</h4>
                  <div class="featured-movie-tags">
                    <p>{{content.category}}</p>
                    <p>{{content.year}}</p>
                    <p
                      v-for="(lang,index) in getLanguage(content.tags)"
                      :key="lang"
                      :style="(index != 0) ? 'padding-left: 10px;border-left:1.5px solid rgba(255, 252, 252, 0.76);margin-right:10px;': 'margin-right:10px;'"
                    >{{lang}}</p>
                  </div>
                  <!-- Content Status 
                  v-if="(content.showtype === 'PREMIERE') && (content.premieringstatus === 'AVAILABLE') && ((new Date() >= new Date(content.fromdate)) && (new Date() <= new Date(content.todate)))"
                  -->
                </div>
                <div class="clearfix"></div>
                <div @click="showDetail(content)" class="arrowStyle card-feature-arrow-down">
                  <img src="@/assets/icons/expandarrow.png" alt="expandarrow" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-container">
      <ContentDetailCard
        v-if="detailcontent"
        :category="'Featured'"
        :cardContent="detailcontent"
        :closePopupEvent="() => closeContentDetail()"
      />
    </div>
  </div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider.module";
import { mapGetters, mapMutations, mapActions } from "vuex";
import App from "@/mixins/App";
import User from "@/mixins/User";
import Utility from "@/mixins/Utility";
import { EventBus } from "@/main";

export default {
  name: "FeaturedCarousel",
  data() {
    return {
      contents: null,
      contentsCopy: null,
      slider: null,
      cardHeight: 500,
      inHomePage: true,
      detailcontent: null,
      showFeaturedCarousel: true
    };
  },
  components: {
    FeaturedPlaceholder: () =>
      import("@/components/Carousels/FeaturedPlaceholder.vue"),
    ContentDetailCard: () =>
      import("@/components/Templates/ContentDetailCard.vue")
  },
  computed: {
    ...mapGetters(["subscriberid", "country", "contentList", "AppConfig"]),
    pageName() {
      return this.$route.name;
    }
  },
  deactivated() {
    // this.showFeaturedCarousel = false;
  },
  activated() {
    // this.showFeaturedCarousel = true;
  },
  watch: {
    subscriberid() {
      if (this.subscriberid) {
        this.getTicketList();
      }
    },
    country() {
      if (this.country) {
        // console.log('from watch');
        this.renderFeaturedCarousel();
      }
    }
  },
  created() {
    // console.log('featured courosel check');
    //
    this.fetchCardHeight();
    // this.renderFeaturedCarousel();

    EventBus.$on("TicketPurchase", data => {
      if (data && data.contentid && data.ticketid) {
        EventBus.$emit('DetailPurchase');
        this.updateContentTicket(data);
      }
    });
  },
  mounted() {
    EventBus.$on("CloseFeaturedDetail", () => {
      this.closeContentDetail();
    });
    if (this.country) {
      if (!this.contentList) {
        // console.log('from renderfeature carousel')
        this.renderFeaturedCarousel();
      } else {
        // console.log('from constructcarousel')
        this.constructCarousel();
      }
    }
  },
  beforeDestroy() {
    if (this.slider) {
      // remove function binding
      this.slider.events.off("indexChanged", this.indexChanged);
      this.slider.destroy();
    }
  },
  methods: {
    ...mapActions(["actListContents", "actListTicket"]),
    ...mapMutations(["commitNewTicket"]),
    updateContentTicket(data) {
      let index = this.contents.findIndex(
        ele => ele.contentid === data.contentid
      );
      if (index > -1) {
        this.contents[index].ticketStatus = true;
        // this.contents[index].purchaseDetails = data;
        this.getTicketList()
      }
    },
    constructCarousel() {
      let featuredData = [...this.contentList];
      // featuredData = featuredData.splice(0, 3);
      this.contents = this.contentsCopy = featuredData;
      this.contents.forEach(element => {
        element.ticketStatus = false;
      });

      if (this.subscriberid) {
        this.getTicketList();
      }
      let isLoop = false;
      let autoplay = false;
      if (featuredData.length > 1) {
        isLoop = true;
        autoplay = true;
      }
      let isRewind = false;
      if (featuredData.length < 3) {
        isRewind = true;
      }
      if (document.getElementById("featured-carousel")) {
        this.$nextTick(() => {
          if (this.slider) this.slider.destroy();
          if (!document.getElementById("featured-carousel")) return;
          this.slider = tns({
            container: `#featured-carousel`,
            controlsContainer: `#slide-feature-controls`,
            slideBy: "page",
            // navContainer: '#ft-nav-container',
            autoplay: true,
            autoplayHoverPause: false,
            autoplayButtonOutput: false,
            autoHeight: true,
            freezable: false,
            loop: isLoop,
            rewind: isRewind,
            controls: true,
            nav: false,
            autoplayTimeout: 2000,
            // speed: 200,
            responsive: {
              1200: {
              items: 1,
              gutter: 5,
              edgePadding: 95,
              },
              1024: {
              items: 1,
              gutter: 5,
              edgePadding: 95,
              },
              768: {
              items:1,
              gutter: 5,
              edgePadding: 95,
              },
              576: {
              items:1,
              gutter:3,
              edgePadding:40,
              }
              // 576: {
              //   items: 1,
              //   gutter: 50,
              //   edgePadding: 300
              // },
              // 768:{
              //   items: 1,
              //   gutter: 5,
              //   edgePadding: 190
              // },
              // // 700: {
              // //   items: 1,
              // //   gutter: 25,
              // //   edgePadding: 190
              // // },
              // 900: {
              //   items: 1,
              //   gutter: 25,
              //   edgePadding: 190
              // }
            }
          });
          // bind function to event
          this.slider.events.on("indexChanged", this.indexChanged);
        });
      }
    },
    detailClick(content) {
      if ((this.isMobile() && content) || (this.isTablet() && content)) {
        if (window.innerWidth < 1990) {
          this.$router.push({
            name: "Detail",
            params: {
              id: content.contentid
            }
          });
        }
      }
    },
    indexChanged(info, eventName) {
      if (info) {
        let indexCurrent = info.displayIndex;
        if (this.detailcontent) {
          let content = this.contents[indexCurrent - 1];
          if (content) {
            // this.showDetail(content)
          }
        } else {
          if (indexCurrent) {
            let content = this.contents[indexCurrent - 1];
            if (indexCurrent == 1) {
              if (this.slider) {
                this.slider.pause();
                setTimeout(() => {
                  this.slider.play();
                }, 4000);
              }
            }
          }
        }
      }
    },
    getTicketList() {
      this.actListTicket()
        .then(response => {
          this.commitNewTicket(false);
          if (response.length > 0) {
            this.contents.forEach(element => {
              let index = response.findIndex(
                ele => ele.contentid === element.contentid
              );
              if (index > -1) {
                let symbol = '';
                let content = response[index];
                // console.log('actual content', content);
                if (content.currency) {
                  symbol = this.AppConfig.payment.price.filter(ele => {
                     if (ele.currencycode = content.currency) {
                       return ele.currencysymbol
                     }
                  })
                }
                // console.log('symbol', symbol);
                let data = {
                  currency: content.currency,
                  currencySymbol: symbol.currencysymbol,
                  ticketid: content.ticketid,
                  ticketprice: content.ticketprice,
                  created: content.created,
                  expiry: content.expiry
                };
                // console.log('data for content detail', data);
                element.purchaseDetails = data;
              }
            });
          }
        })
        .catch(error => {
          if (error.status === 401) {
            this.sessionExpiredCB();
            EventBus.$emit("logOut");
            // window.location.reload()
            this.$router.push({ name: "Home" });
          }
        });
    },
    getLanguage(lang) {
      let contentLanguage = "";

      lang.forEach(element => {
        let str = element.includes("Lang");
        if (str) {
          let str2 = element.split("-");
          if (str2 && str2.length > 1) {
            contentLanguage = str2[1].split("|");
          }
        }
      });
      return contentLanguage;
    },
    navBtnClickCB() {
      setTimeout(() => {
        this.slider.play();
      }, 1000);
    },
    contentCursorHover() {
      if (this.slider) {
        this.slider.pause();
      }
    },
    contentCursorNotHover() {
      if (this.slider && !this.detailcontent) {
        if (this.slider.play) this.slider.play();
      }
    },
    showDetail(content) {
      EventBus.$emit("CloseMoviesDetail");
      this.detailcontent = content;
      this.contentCursorHover();
    },
    closeContentDetail() {
      this.detailcontent = null;
      this.contentCursorNotHover();
    },
    renderFeaturedCarousel() {
      let route = this.$route;
      let params = {};
      if (route.name != "Home") {
        params.contenttype = route.name;
      }
      this.contents = null;
      // if (this.slider) this.slider.destroy();
      this.actListContents(params)
        .then(response => {
          if (response && response.length) {
            let featuredData = [...response];
            // featuredData = featuredData.splice(0, 3);
            this.contents = this.contentsCopy = featuredData;
            this.contents.forEach(element => {
              element.ticketStatus = false;
            });

            if (this.subscriberid) {
              this.getTicketList();
            }
            let isLoop = false;
            let autoplay = false;
            if (featuredData.length > 1) {
              isLoop = true;
              autoplay = true;
            }
            let isRewind = false;
            if (featuredData.length < 3) {
              isRewind = true;
            }
            if (route.name != this.$route.name) return false;
            if (document.getElementById("featured-carousel")) {
              this.$nextTick(() => {
                if (this.slider) return;
                if (!document.getElementById("featured-carousel")) return;
                this.slider = tns({
                  container: `#featured-carousel`,
                  controlsContainer: `#slide-feature-controls`,
                  slideBy: "page",
                  // navContainer: '#ft-nav-container',
                  autoplay: true,
                  autoplayHoverPause: false,
                  autoplayButtonOutput: false,
                  autoHeight: true,
                  freezable: false,
                  loop: isLoop,
                  rewind: isRewind,
                  controls: true,
                  nav: false,
                  autoplayTimeout: 2000,
                  // speed: 200,
                  responsive: {
                    1200: {
                    items: 1,
                    gutter: 5,
                    edgePadding: 95,
                    },
                    1024: {
                    items: 1,
                    gutter: 5,
                    edgePadding: 95,
                    },
                    768: {
                    items:1,
                    gutter: 5,
                    edgePadding: 95,
                    },
                    576: {
                    items:1,
                    gutter:3,
                    edgePadding:40,
                    }
                    // 576: {
                    //   items: 1,
                    //   gutter: 50,
                    //   edgePadding: 300
                    // },
                    // 660: {
                    //   items: 1,
                    //   gutter: 25,
                    //   edgePadding: 190
                    // },
                    // 700: {
                    //   items: 1,
                    //   gutter: 25,
                    //   edgePadding: 190
                    // },
                    // 900: {
                    //   items: 1,
                    //   gutter: 25,
                    //   edgePadding: 190
                    // }
                  }
                });
                // bind function to event
                this.slider.events.on("indexChanged", this.indexChanged);
              });
            }
          }
        })
        .catch(error => {
          if (error.status === 401) {
            this.sessionExpiredCB();
            this.$router.push({ name: "Home" });
            EventBus.$emit("logOut");
            // window.location.reload()
          }
        });
    },
    getPoster(content) {
      if (content.posters.length) {
        let landscapeposters = content.posters.filter(
          pos => pos.orientation === "LANDSCAPE"
        );
        if (landscapeposters.length) {
          let posterIndex = landscapeposters.findIndex(
            pos => pos.quality === "HD"
          );
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    },
    fetchCardHeight() {
      let bodyWidth = document.body.offsetWidth - 500;
      let cardHeight = Math.round(bodyWidth / (16 / 9));
      if (cardHeight) {
        this.cardHeight = cardHeight + 10;
        if (this.isTablet()) {
          this.cardHeight += 50;
        }
      }
    }
  },
  mixins: [App, User, Utility]
};
</script>

<style lang="scss">
@import "~sass/modules/variables";
.left-misc {
  float: left;
}
.right-misc {
  float: right;
}
.slick-dotted.slick-slider {
  margin: 0;
}
.ft-container {
  position: relative;
  margin: 10px;
}
.ft-card {
  // opacity: 0.4;
  transition: all 0.3s ease;
  position: relative;

  &.tns-slide-active {
    opacity: 1;
  }

  .ft-card-misc {
    position: absolute;
    left: 0;
    // top: 75%;
    bottom: 0%;
    width: 100%;
    color: #fff;
    z-index: 10;
    padding: 20px;
    padding-bottom: 3.5%;
    padding-left: 45px;
    opacity: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 41%,
      rgba(0, 0, 0, 0.85) 100%
    );
  }
  &:hover {
    .ft-card-misc {
      opacity: 1;
      transition: all 0.3s ease;
    }
    .arrowStyle {
      opacity: 1;
    }
  }

  .ft-card-left {
    float: left;
    opacity: 0;
    width: 65%;
    margin-top: 5%;
    .card-title {
      font-size: 44px;
      text-transform: uppercase;
      font-family: "ProximanovaBold";
      text-shadow: 2px 2px 6px #000000;
    }
    .featured-movie-tags {
      display: flex;
      p {
        float: left;
        opacity: 0.76;
        color: #ffffff;
        font-family: "ProximanovaRegular";
        font-size: 18px;
        line-height: 15px;
        margin-right: 25px;
        text-transform: uppercase;
      }
    }
  }
  .card-ioncs {
    img {
      margin-bottom: 20px;
      width: 30px;
      float: left;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .card-book-btn {
    width: 60%;
  }
}
.tns-slide-active {
  .ft-card-left,
  .ft-card-right {
    opacity: 1;
  }
}
.ft-card-box {
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  -moz-box-shadow: 0 8px 6px -6px black;
  -webkit-box-shadow: 0 8px 6px -6px black;
  box-shadow: 0 8px 6px -6px black;
  &:hover {
    z-index: 1000;
    // transform: translateY(-10px);
    // transform: translateY(-8px) scale(1.005) translateZ(0);
    // transition: all 0.5s ease-out;
    -webkit-transition: all 0.5s ease-in-out;
    -webkit-transform: scale(1.04);
    -ms-transition: all 0.5s ease-in-out;
    -ms-transform: scale(1.04);
    -moz-transition: all 0.5s ease-in-out;
    -moz-transform: scale(1.04);
    transition: all 0.5s ease-in-out;
    transform: scale(1.04);
  }

  .ft-card-box-contain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  &::before {
    position: absolute;
    content: "";
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.62), transparent);
    left: 0;
    bottom: 0;
    height: 25%;
    width: 100%;
    z-index: 9;
  }
}

.ft-nav-container {
  text-align: center;
  padding: 10px 0;

  button {
    border: 2px solid #c0c0c0;
    width: 11px;
    height: 11px;
    border-radius: 15px;
    margin-right: 15px;
    cursor: pointer;
    &.tns-nav-active {
      background-color: #c0c0c0;
    }
  }
}
.arrowStyle {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #fff;
  z-index: 10;
  opacity: 0;
}
.detail-container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
  width: 90%;
  margin-top: 20px;
}
.featured-share-btn {
  float: left;
  margin-right: 5px;
  .share-popup {
    width: 250px !important;
    img {
      margin-bottom: 0;
    }
  }
}
.card-watchlist-btn {
  button {
    img {
      width: 36px !important;
    }
  }
}
#featured-carousel-mw {
  overflow: visible;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
}

.featured-share-btn {
  margin-right: 2px;
  .share-popup {
    width: 170px !important;
  }
}
.arrowStyle {
  opacity: 0;
}
.card-arrow-down {
  img {
    height: 25px !important;
  }
}
.ft-container {
  :hover {
    #slide-feature-controls {
      opacity: 1;
      transition: 0.1s ease-in;
    }
  }
}
#slide-feature-controls {
  opacity: 0;
  img {
    width: 35px;
  }
  button {
    height: 100%;
    width: 8%;
    margin: 0;
  }
  .btn-slide-controls {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    &:disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }
  }
  .prev {
    position: absolute;
    z-index: 100;
    // top: 45%;
    // left: 1%;
    // background: linear-gradient(to right, rgba(0, 0, 0, 1), transparent);
  }
  .next {
    position: absolute;
    right: 0%;
    // top: 45%;
    z-index: 100;
    // background: linear-gradient(to left, rgba(0, 0, 0, 1), transparent);
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (max-width: 600px) {
  #featured-carousel-mw {
    height: 200px !important;
  }
  .ft-card-box {
    height: 200px !important;
    margin: 0 20px;
  }
  .card-title {
    font-size: 20px;
  }
  .ft-container {
    :hover {
      #slide-feature-controls {
        opacity: 0;
      }
      .ft-card-misc{
        opacity: 0;
      }
    }
  }
}
.card-feature-arrow-down {
  text-align: center;
  img {
    cursor: pointer;
    height: 20px;
    margin-bottom: 5px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
// @media only screen and (max-width: 600px) {
//   .ft-container{
//     // height: 350px !important;
//     margin: 2em 0 2em;
//     :hover {
//       #slide-feature-controls {
//         opacity: 0;
//       }
//     }
//   }
//   .ft-card-box {
//     // height: 350px !important;
//     margin: 0 20px;
//   }
// }

/* Medium devices (landscape tablets, 768px and up) */
// @media only screen and (max-width: 768px) {
//   .ft-card {
//     .ft-card-misc {
//       display: none;
//     }
//   }
//   // .ft-container {
//   //   margin: 2em 0 2em;
//   //   :hover {
//   //     #slide-feature-controls {
//   //       opacity: 0;
//   //     }
//   //   }
//   // }
// }
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) and (max-width: 992px) {
  .ft-container {
    height: 350px !important;
    margin: 15px 0;
    :hover {
      #slide-feature-controls {
        opacity: 0;
      }
    }
  }
  .ft-card-box {
    height: 350px !important;
    margin: 0 20px;
  }
  .ft-card {
    .ft-card-misc {
      display: none;
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .ft-container{
    height: 500px !important;
    margin: 15px 0;
  }
  .ft-card-box {
    height: 500px !important;
    margin: 0 20px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .ft-container{
    height: 500px !important;
    margin: 15px 0;
  }
  .ft-card-box {
    height: 500px !important;
    margin: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousels/Featured.vue